import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
/******/ var __webpack_modules__ = ({

/***/ 8753:
/***/ ((module) => {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 1801:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(8753);var f=__webpack_require__(810),g=60103;__webpack_unused_export__=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");__webpack_unused_export__=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 3704:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



if (true) {
  module.exports = __webpack_require__(1801);
} else {}


/***/ }),

/***/ 810:
/***/ ((module) => {

var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  L: () => (/* binding */ MarkerUpsActive)
});

;// CONCATENATED MODULE: ../../../../node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(3704);
;// CONCATENATED MODULE: ./icons/MarkerUpsActive.tsx


const MarkerUpsActive = (props) => {
    const { className, brand, dataTestId } = props, rest = __rest(props, ["className", "brand", "dataTestId"]);
    if (brand === 'ck')
        return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'marker-ups-active-svg', width: 36, height: 48, viewBox: "0 0 36 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 48C30 36.91 36 27.325 36 19.245C36 7.875 27.9375 0 18 0C8.0625 0 0 7.98 0 19.245C0 27.325 6 36.91 18 48Z", fill: "#301506" }), (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.52539 15.6831L5.64059 28.6047L8.54619 32.1951L17.2566 36.8031L27.9574 31.5999L30.159 26.2751L29.9478 9.13592L21.839 8.90552L13.4422 10.2751L5.76219 14.7167L5.52539 15.6831Z", fill: "#301506" }), (0,jsx_runtime.jsx)("path", { d: "M17.9995 6.3457C12.9243 6.3457 8.50185 7.3249 4.84105 9.2641V24.7521C4.79266 26.2499 5.08825 27.7389 5.70511 29.1046C6.32197 30.4704 7.24369 31.6766 8.39945 32.6305C10.5499 34.3969 17.1995 37.3025 17.9995 37.6545C18.7739 37.3217 25.5002 34.3649 27.5995 32.6305C28.7545 31.6759 29.6757 30.4696 30.2925 29.104C30.9093 27.7384 31.2053 26.2498 31.1579 24.7521V9.2641C27.4971 7.3249 23.0747 6.3457 17.9995 6.3457ZM25.5131 9.3409C27.0235 9.3409 28.5082 9.4561 29.9482 9.5905V24.7521C29.9991 26.0696 29.7462 27.3811 29.2091 28.5853C28.6719 29.7894 27.865 30.8538 26.8507 31.6961C25.0395 33.2001 19.5291 35.6577 17.9995 36.3361C16.4443 35.6513 10.9595 33.1361 9.14825 31.6961C8.13504 30.8528 7.32888 29.7882 6.79185 28.5844C6.25482 27.3805 6.00125 26.0694 6.05065 24.7521V15.8945C11.8811 10.5505 18.9531 9.2577 25.5131 9.3409ZM18.3387 16.3809C17.2521 16.3441 16.1789 16.6291 15.2539 17.2001V32.1121H17.5451V27.3121C17.8799 27.4078 18.2272 27.4531 18.5755 27.4465C21.1355 27.4465 22.5755 25.1553 22.5755 21.8145C22.5755 18.4737 21.0715 16.4001 18.3387 16.4001V16.3809ZM26.1658 16.3809C25.3645 16.3808 24.5954 16.6965 24.0252 17.2596C23.455 17.8226 23.1296 18.5876 23.1195 19.3889C23.1195 20.6049 23.4587 21.5137 25.3466 22.5889C26.3578 23.1777 26.7611 23.5681 26.7803 24.2913C26.7902 24.4704 26.7605 24.6494 26.6935 24.8158C26.6264 24.9821 26.5236 25.1317 26.3923 25.2539C26.261 25.376 26.1044 25.4678 25.9336 25.5226C25.7629 25.5775 25.5821 25.5941 25.4042 25.5713C24.5907 25.5133 23.8201 25.1843 23.2155 24.6369V26.7489C23.9599 27.202 24.8085 27.4555 25.6795 27.4849C26.1017 27.5156 26.5257 27.4592 26.9253 27.3193C27.3248 27.1793 27.6914 26.9588 28.0022 26.6714C28.313 26.384 28.5615 26.0358 28.7322 25.6484C28.9029 25.261 28.9923 24.8426 28.9946 24.4193C29.0394 23.0881 28.6682 22.0769 26.761 20.9505C25.9035 20.4513 25.2315 20.1249 25.2507 19.2929C25.2699 18.4609 25.9482 18.1921 26.601 18.1985C27.3792 18.2375 28.1125 18.5743 28.649 19.1393V17.1489C27.9246 16.6165 27.038 16.3519 26.1403 16.4001L26.1658 16.3809ZM7.22185 16.6177V23.8305C7.22185 26.2561 8.36745 27.4849 10.6331 27.4849C11.8492 27.5299 13.0509 27.2088 14.0827 26.5633V16.6369H11.7979V25.2641C11.4715 25.4585 11.0958 25.554 10.7163 25.5393C9.67945 25.5393 9.50665 24.5601 9.50665 23.9201V16.6369L7.22185 16.6177ZM18.3579 18.2241C19.6827 18.2241 20.2331 19.2865 20.2331 21.8529C20.2331 24.4193 19.5931 25.5585 18.3131 25.5585C18.0596 25.5581 17.8082 25.5126 17.5707 25.4241V18.3841C17.8272 18.2731 18.1039 18.2164 18.3835 18.2177L18.3579 18.2241Z", fill: "#FAB80A" })] })));
    return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'marker-ups-active-svg', width: 36, height: 48, viewBox: "0 0 36 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 48C30 36.91 36 27.325 36 19.245C36 7.875 27.9375 0 18 0C8.0625 0 0 7.98 0 19.245C0 27.325 6 36.91 18 48Z", fill: "#301506" }), (0,jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.52539 15.6831L5.64059 28.6047L8.54619 32.1951L17.2566 36.8031L27.9574 31.5999L30.159 26.2751L29.9478 9.13592L21.839 8.90552L13.4422 10.2751L5.76219 14.7167L5.52539 15.6831Z", fill: "#301506" }), (0,jsx_runtime.jsx)("path", { d: "M17.9995 6.3457C12.9243 6.3457 8.50185 7.3249 4.84105 9.2641V24.7521C4.79266 26.2499 5.08825 27.7389 5.70511 29.1046C6.32197 30.4704 7.24369 31.6766 8.39945 32.6305C10.5499 34.3969 17.1995 37.3025 17.9995 37.6545C18.7739 37.3217 25.5002 34.3649 27.5995 32.6305C28.7545 31.6759 29.6757 30.4696 30.2925 29.104C30.9093 27.7384 31.2053 26.2498 31.1579 24.7521V9.2641C27.4971 7.3249 23.0747 6.3457 17.9995 6.3457ZM25.5131 9.3409C27.0235 9.3409 28.5082 9.4561 29.9482 9.5905V24.7521C29.9991 26.0696 29.7462 27.3811 29.2091 28.5853C28.6719 29.7894 27.865 30.8538 26.8507 31.6961C25.0395 33.2001 19.5291 35.6577 17.9995 36.3361C16.4443 35.6513 10.9595 33.1361 9.14825 31.6961C8.13504 30.8528 7.32888 29.7882 6.79185 28.5844C6.25482 27.3805 6.00125 26.0694 6.05065 24.7521V15.8945C11.8811 10.5505 18.9531 9.2577 25.5131 9.3409ZM18.3387 16.3809C17.2521 16.3441 16.1789 16.6291 15.2539 17.2001V32.1121H17.5451V27.3121C17.8799 27.4078 18.2272 27.4531 18.5755 27.4465C21.1355 27.4465 22.5755 25.1553 22.5755 21.8145C22.5755 18.4737 21.0715 16.4001 18.3387 16.4001V16.3809ZM26.1658 16.3809C25.3645 16.3808 24.5954 16.6965 24.0252 17.2596C23.455 17.8226 23.1296 18.5876 23.1195 19.3889C23.1195 20.6049 23.4587 21.5137 25.3466 22.5889C26.3578 23.1777 26.7611 23.5681 26.7803 24.2913C26.7902 24.4704 26.7605 24.6494 26.6935 24.8158C26.6264 24.9821 26.5236 25.1317 26.3923 25.2539C26.261 25.376 26.1044 25.4678 25.9336 25.5226C25.7629 25.5775 25.5821 25.5941 25.4042 25.5713C24.5907 25.5133 23.8201 25.1843 23.2155 24.6369V26.7489C23.9599 27.202 24.8085 27.4555 25.6795 27.4849C26.1017 27.5156 26.5257 27.4592 26.9253 27.3193C27.3248 27.1793 27.6914 26.9588 28.0022 26.6714C28.313 26.384 28.5615 26.0358 28.7322 25.6484C28.9029 25.261 28.9923 24.8426 28.9946 24.4193C29.0394 23.0881 28.6682 22.0769 26.761 20.9505C25.9035 20.4513 25.2315 20.1249 25.2507 19.2929C25.2699 18.4609 25.9482 18.1921 26.601 18.1985C27.3792 18.2375 28.1125 18.5743 28.649 19.1393V17.1489C27.9246 16.6165 27.038 16.3519 26.1403 16.4001L26.1658 16.3809ZM7.22185 16.6177V23.8305C7.22185 26.2561 8.36745 27.4849 10.6331 27.4849C11.8492 27.5299 13.0509 27.2088 14.0827 26.5633V16.6369H11.7979V25.2641C11.4715 25.4585 11.0958 25.554 10.7163 25.5393C9.67945 25.5393 9.50665 24.5601 9.50665 23.9201V16.6369L7.22185 16.6177ZM18.3579 18.2241C19.6827 18.2241 20.2331 19.2865 20.2331 21.8529C20.2331 24.4193 19.5931 25.5585 18.3131 25.5585C18.0596 25.5581 17.8082 25.5126 17.5707 25.4241V18.3841C17.8272 18.2731 18.1039 18.2164 18.3835 18.2177L18.3579 18.2241Z", fill: "#FAB80A" })] })));
};

})();

var __webpack_exports__MarkerUpsActive = __webpack_exports__.L;
export { __webpack_exports__MarkerUpsActive as MarkerUpsActive };
